import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'icon-chevron-right',
  templateUrl: './icon-chevron-right.component.html',
  styleUrls: ['./icon-chevron-right.component.scss'],
})
export class IconChevronRightComponent  implements OnInit {
  @Input() size :number = 20;
  constructor() { }

  ngOnInit() {}

}
